import { TimeQuestionConfig, TimeType } from '@gripp/shared-logic';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { ControlledSelect } from '../../../../forms';
import {
  RoutineQuestionAdminForm,
  RoutineQuestionAdminFormProps,
} from '../types';
import { themedStyleSheet } from '../../../../../themes/themedStyleSheet';

export const TimeQuestionAdminForm: RoutineQuestionAdminForm<
  TimeQuestionConfig
> = (props: RoutineQuestionAdminFormProps<TimeQuestionConfig>) => {
  const { t } = useTranslation();
  const i18nPrefix = 'routines.time.admin';

  const timeTypes = useMemo(() => {
    const types: { label: string; value: TimeType }[] = [];
    const typePrefix = 'routines.time.timeTypes';
    const enumKeys = Object.keys(TimeType).filter(
      (key) => typeof TimeType[key as keyof typeof TimeType] === 'string'
    );

    for (const key of enumKeys) {
      const value = TimeType[key as keyof typeof TimeType];
      const label = t(`${typePrefix}.${value}`);
      types.push({ label, value });
    }

    return types;
  }, [t]);

  const timeTypeFieldName = props.indexPrefix
    ? `${props.indexPrefix}.timeType`
    : 'timeType';

  const startEndTimesFieldName = props.indexPrefix
    ? `${props.indexPrefix}.timeTypeValue`
    : 'timeTypeValue';

  props.control.register(startEndTimesFieldName, {
    value: props.config.timeTypeValue ?? '',
  });

  props.control.register(timeTypeFieldName, {
    value: props.config?.timeType ?? TimeType.StartEndTimes,
  });

  return (
    <View style={styles.container}>
      <View style={styles.timeTypeContainer}>
        <Text style={styles.timeTypeTitle}>{t(`${i18nPrefix}.time`)}</Text>
        <ControlledSelect
          control={props.control}
          name={timeTypeFieldName}
          label={''}
          items={timeTypes}
          dropDownPickerProps={{
            scrollViewProps: {
              nestedScrollEnabled: true,
            },
            dropDownContainerStyle: [
              styles.dropdownListContainer,
              { minHeight: 100 },
            ],
          }}
        />
      </View>
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    justifyContent: 'flex-start',
  },
  timeTypeTitle: {
    color: role.textPrimary,
    fontSize: 16,
    fontWeight: '600',
    letterSpacing: -0.25,
    marginBottom: 12,
  },
  timeTypeContainer: {
    maxWidth: 550,
    zIndex: 2,
  },
  dropdownListContainer: {
    position: 'relative',
    top: 0,
  },
}));
